import React from 'react';
import PropTypes from 'prop-types';

import { AsyncSelect } from 'components/ui/async_select';

import Menu from './menu';
import Option from './option';
import { debouncedSearchContacts } from 'bundles/backoffice/contacts/api';

export default class ContactSelect extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    contact: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }),
    disabled: PropTypes.bool,
    iconClassName: PropTypes.string,
    limitToType: PropTypes.oneOf(['business', 'person']),
    menuPlacement: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    // TODO: Support empty states without creation and make this optional
    onCreateClick: PropTypes.func.isRequired
  }

  get contactTypeLabel() {
    return this.props.limitToType === 'business' ? 'company' : 'contact';
  }

  get contactTypeLabelPlural() {
    return this.props.limitToType === 'business' ? 'companies' : 'contacts';
  }

  searchContacts = (query, callback) => {
    if (query) {
      const params = { query };

      if (this.props.limitToType) {
        params.type = this.props.limitToType;
      }

      debouncedSearchContacts(params, callback);
    } else {
      callback([]);
    }
  }

  render() {
    return (
      <AsyncSelect
        aria-label="search"
        className={this.props.className}
        components={{ Menu, Option }}
        contactTypeLabel={this.contactTypeLabel}
        contactTypeLabelPlural={this.contactTypeLabelPlural}
        getOptionLabel={contact => contact.displayName}
        getOptionValue={contact => contact.id}
        isClearable
        isDisabled={this.props.disabled}
        loadOptions={this.searchContacts}
        menuPlacement={this.props.menuPlacement}
        placeholder={`Enter ${this.contactTypeLabel} name or email`}
        value={this.props.contact}
        onChange={this.props.onChange}
        onCreateClick={this.props.onCreateClick}
      />
    );
  }
}
